module.exports = __webpack_public_path__ + "img/all-orders.7bc6d3b9.svg";